import { useState } from "react";
import HeaderComponent from "@components/common/Header/Header";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import EditIcon from "@styles/all-images/icons/edit.svg";
import PlusIcon from "@styles/all-images/icons/plus.svg";
import DownloadIcon from "@styles/all-images/icons/download.svg";
import ListIcon from "@styles/all-images/icons/list-icon.svg";
import UnarchiveIcon from "@styles/all-images/icons/unarchived.svg";
import { useNavigate } from "react-router-dom";
import CustomTable from "@/components/common/table/CustomTable";
import { toast } from "react-toastify";

interface RolePermission {
  RoleId: string;
  RoleName: string;
  CreatedDate: string;
  RoleAssignedCount: string;
  Action: string;
}

const RolesAndPermissions = () => {
  const navigate = useNavigate();
  const [isArchiveView, setIsArchiveView] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);

  const RolesAndPermissionsData = [
    {
      RoleId: "1",
      RoleName: "Role 1",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "2",
      RoleName: "Role 2",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "3",
      RoleName: "Role 3",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "4",
      RoleName: "Role 4",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "5",
      RoleName: "Role 5",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "6",
      RoleName: "Role 6",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "7",
      RoleName: "Role 7",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "8",
      RoleName: "Role 8",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "9",
      RoleName: "Role 9",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "10",
      RoleName: "Role 10",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
    {
      RoleId: "11",
      RoleName: "Role 11",
      CreatedDate: "02/12/2024",
      RoleAssignedCount: "6",
      Action: "",
    },
  ];

  const columns = [
    {
      header: "Role ID",
      accessor: "RoleId" as keyof RolePermission,
      sortable: true,
      sortKey: "roleId",
    },
    {
      header: "Role Name",
      accessor: "RoleName" as keyof RolePermission,
      sortable: true,
      sortKey: "roleName",
    },
    {
      header: "Created Date",
      accessor: "CreatedDate" as keyof RolePermission,
      sortable: true,
      sortKey: "createdDate",
    },
    {
      header: "Action",
      accessor: (row: RolePermission) => (
        <div className="tw-flex tw-items-center tw-gap-5">
          {!isArchiveView ? (
            <>
              <button
                onClick={() => navigate("/edit-add-roles-and-permissions")}
              >
                <img src={EditIcon} alt="Edit Icon" className="tw-w-6 tw-h-6" />
              </button>
              <button className="tw-text-blue-500">
                <img
                  src={DownloadIcon}
                  alt="Download Icon"
                  className="tw-w-6 tw-h-6"
                />
              </button>
            </>
          ) : (
            <button className="tw-text-blue-500">
              <img
                src={UnarchiveIcon}
                alt="Unarchive Icon"
                className="tw-w-6 tw-h-6"
              />
            </button>
          )}
        </div>
      ),
    },
  ];

  // Mock fetchData function - replace with actual API call
  const fetchData = async (filters: any) => {
    try {
      let filteredData = [...RolesAndPermissionsData];

      if (filters.search) {
        filteredData = filteredData.filter((item) =>
          Object.values(item).some((value) =>
            value
              .toString()
              .toLowerCase()
              .includes(filters.search.toLowerCase()),
          ),
        );
      }

      const startIndex = (filters.page - 1) * filters.limit;
      const paginatedData = filteredData.slice(
        startIndex,
        startIndex + filters.limit,
      );

      return {
        data: {
          data: paginatedData,
          meta: {
            count: filteredData.length,
            page: filters.page,
            limit: filters.limit,
          },
        },
      };
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch roles data");
      throw error;
    }
  };

  return (
    <div>
      <HeaderComponent />

      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Roles and Permissions
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="tw-mt-[147px]">
        <CustomTable
          columns={columns}
          fetchData={fetchData}
          forceRefresh={forceRefresh}
          setForceRefresh={setForceRefresh}
          addButton={{
            text: "Add Role",
            icon: PlusIcon,
            onClick: () => navigate("/edit-add-roles-and-permissions"),
          }}
          archiveButton={{
            text: isArchiveView ? "Back to List" : "Archived",
            icon: isArchiveView ? ListIcon : DownloadIcon,
            onClick: () => setIsArchiveView(!isArchiveView),
            isArchiveView,
          }}
        />
      </div>
    </div>
  );
};

export default RolesAndPermissions;
